import { TaggingRuleActionType } from './enums'

export const ACTION_TYPE_TITLE = {
  [TaggingRuleActionType.ADD_TAG]: 'Add tags',
  [TaggingRuleActionType.SET_CATEGORY]: 'Set Category',
  [TaggingRuleActionType.SET_SUB_CATEGORY]: 'Set Subcategory',
  [TaggingRuleActionType.SET_COUNTERPARTY]: 'Set Counterparty',
  [TaggingRuleActionType.SET_SIGN]: 'Set Sign',
}
